import { render } from "./package-upload.vue?vue&type=template&id=db68be3e"
import script from "./package-upload.vue?vue&type=script&lang=js"
export * from "./package-upload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__